import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_FIELDS } from '@src/graphql/fragments/ehrAppointment'

export const UPDATE_APPOINTMENT_KIND = gql`
  ${EHR_APPOINTMENT_FIELDS}
  mutation updateEhrAppointmentKind($id: ID!, $appointmentKind: EhrAppointmentKind!) {
    updateEhrAppointmentKind(id: $id, appointmentKind: $appointmentKind) {
      ...EhrAppointmentFields
    }
  }
`
